// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"highlight-1"},"nodeName":"g","children":[{"attributes":{"id":"fill1","cx":12,"cy":12,"r":10,"fill":"transparent"},"nodeName":"circle","children":[]},{"attributes":{"id":"stroke1","cx":12,"cy":12,"r":10,"stroke":"currentColor","stroke-width":2},"nodeName":"circle","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M6.77539 9.04812C7.8058 7.22821 9.75958 6 12.0002 6M6.00391 12.2091L6.00391 12.1328","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-highlight-1')
export default class Highlight1Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'highlight-1',
    }
  }
}
